import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CustomPartCategoryPage } from '@/areas/settings/OrganizationSettings/pages/CustomPartCategoryPage';
import { canViewGeneralSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/custom-part-categories')({
    staticData: {
        access: { permissions: canViewGeneralSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CustomPartCategoryPage />;
}
